import styled from '@emotion/styled';
import navigateLeftIcon from '~/Assets/icons//navigate-left.svg';
import navigateRightIcon from '~/Assets/icons//navigate-right.svg';
import { BlackButton, Button } from '~Styles';
import { handyBreakpoint } from '~Styles/breakpoints';

export const Header = styled.div`
  background-color: #fff;
  padding: 14px 8px;
  display: flex;
  align-items: center;
`;

export const Title = styled.div`
  font-size: 25px;
  color: #3a3a3a;
  font-weight: bold;
`;

export const CalendarWrapper = styled.div`
  padding: 16px;
  width: 350px;
  box-sizing: border-box;

  ${handyBreakpoint} {
    width: 100%;
  }
`;

export const DateNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
`;

export const Prev = styled.div`
  width: 48px;
  height: 48px;
  mask-image: url('${navigateLeftIcon}');
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #3a3a3a;
  margin-right: 12px;
`;

export const Next = styled.div`
  width: 48px;
  height: 48px;
  mask-image: url('${navigateRightIcon}');
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #3a3a3a;
  margin-left: 12px;
`;

export const DateText = styled.span`
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 20px;
`;

export const ReportWrapper = styled.div`
  flex: 1;
  height: calc(100vh - 128px);
  overflow: auto;

  ${handyBreakpoint} {
    height: auto;
    overflow: visible;
    padding-bottom: 40px;
  }
`;

export const Report = styled.pre`
  white-space: pre-wrap;
  padding-bottom: 100px;
`;

export const PrintAllStaffReportsButton = styled(BlackButton)`
  text-transform: none;
`;

export const ToggleReportButton = styled(Button)<{ selected: boolean }>`
  background-color: var(--colorWhite);
  text-transform: none;
  border: ${({ selected }) =>
    selected ? '1px solid var(--colorBlack)' : '1px solid var(--colorWhite)'};
  width: 50%;
`;

export const MobileDateInput = styled.div`
  display: none;

  ${handyBreakpoint} {
    display: block;
  }
`;

export const LargeCalendarWrapper = styled.div`
  display: block;

  ${handyBreakpoint} {
    display: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-flow: row;

  ${handyBreakpoint} {
    flex-flow: column;
  }
`;
